
import * as ipxServiceRuntime$payvpMpKoq from '/app/apps/crm/src/app/providers/ipx-service.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "thumbnail": {
      "modifiers": {
        "format": "webp",
        "width": 200,
        "height": 200,
        "quality": 75
      }
    },
    "slider": {
      "modifiers": {
        "format": "webp",
        "width": 400,
        "height": 237,
        "quality": 75
      }
    },
    "sliderContent": {
      "modifiers": {
        "format": "webp",
        "width": 780,
        "height": 400,
        "quality": 75
      }
    },
    "sliderThumbnail": {
      "modifiers": {
        "format": "webp",
        "width": 76,
        "height": 76,
        "quality": 55
      }
    },
    "sliderLargeThumbnail": {
      "modifiers": {
        "format": "webp",
        "width": 122,
        "height": 122,
        "quality": 70
      }
    }
  },
  "provider": "ipxService",
  "domains": [],
  "alias": {
    "/delta": "https://img.carsindigo.com",
    "/placehold": "https://placehold.it"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipxService']: { provider: ipxServiceRuntime$payvpMpKoq, defaults: {} }
}
        